document.addEventListener('DOMContentLoaded', function () {
  const bundleRoot = document.querySelector('.\\#tdlv-product-bundle');
  if (!bundleRoot) return;

  // Scope to the form that actually wraps this bundle block
  const bundleForm = bundleRoot.closest('form[data-type="add-to-cart-form"]');
  const allForms = Array.from(document.querySelectorAll('form[data-type="add-to-cart-form"]'));
  const otherForm = allForms.find(f => f !== bundleForm) || null;
  const otherAddButton = otherForm ? (otherForm.querySelector('button[type="submit"], button[name="add"], [data-element="to-cart-button"] button')) : null;
  const otherQtyInput = otherForm ? (otherForm.querySelector('input[name="quantity"], input[type="number"][data-quantity]')) : null;
  const bundleQtyInput = bundleRoot.querySelector('[data-bundle-qty-input]');
  const mainQtyHidden = bundleForm ? bundleForm.querySelector('input[name="quantity"][data-bundle-main-qty]') : null;
  function getNativeQtyContainer() {
    const byId = document.getElementById('product-qty-selector-buttons');
    if (byId) return byId;
    const byClass = document.querySelector('.\\#product-qty-selector');
    if (byClass) return byClass.closest('product-variant-listener') || byClass;
    return otherQtyInput ? (otherQtyInput.closest('[data-quantity], .quantity, .product-form__quantity, .product-quantity, fieldset, div')) : null;
  }
  const nativeQtyContainer = getNativeQtyContainer();
  const DEBUG = (new URLSearchParams(location.search).get('pb') === '0') || sessionStorage.getItem('tdlvBundleDebug') === '1';
  const log = (...args) => { if (DEBUG) console.log('[TDLV]', ...args); };
  let radioInputs = bundleRoot.querySelectorAll('input[type="radio"]');
  // Ensure a hidden "none" option exists so we can clear selection on label/input click
  (function ensureNoneRadio() {
    const existingNone = bundleRoot.querySelector('input[type="radio"][data-bundle-none]');
    if (existingNone) return;
    const first = radioInputs[0];
    if (!first) return;
    const none = document.createElement('input');
    none.type = 'radio';
    none.name = first.name;
    none.value = '';
    none.setAttribute('data-bundle-none', '');
    none.style.display = 'none';
    none.style.position = 'absolute';
    none.style.left = '-9999px';
    bundleRoot.insertBefore(none, bundleRoot.firstChild);
    log('created hidden none radio', { name: none.name });
    // Re-query to include the new none radio
    radioInputs = bundleRoot.querySelectorAll('input[type="radio"]');
  })();
  const totalPriceEl = bundleRoot.querySelector('[data-element="subtotal"]');
  const addToCartBtn = bundleRoot.querySelector('.\\#tdlv-product-bundle-button');
  const bundleItems = bundleRoot.querySelectorAll('.\\#tdlv-product-bundle-item');
  const mainProductEl = document.querySelector('#main-product');
  const mainProductPrice = mainProductEl ? parseFloat(mainProductEl.dataset.priceValue) : 0;
  const footer = bundleRoot.querySelector('[data-element="footer"]');

  footer.classList.add('desktop-hidden', 'mobile-hidden');
  // Ensure the native button is visible on load; we will hide it once a bundle is selected
  if (otherAddButton) otherAddButton.style.display = '';
  log('Initialized', { bundleRoot, bundleForm, radios: radioInputs.length, mainProductPrice });
  if (!bundleForm) log('ERROR: bundleForm not found near bundleRoot');
  
  // Debug: check main product inputs and form structure
  const mainProductInput = document.querySelector('#main-product');
  const mainProductQty = document.querySelector('input[name="items[0][quantity]"]');
  const allItemsInputs = document.querySelectorAll('input[name^="items["]');
  log('Form structure debug', { 
    mainProduct: mainProductInput, 
    mainQty: mainProductQty, 
    allItemsInputs: Array.from(allItemsInputs).map(inp => ({name: inp.name, value: inp.value, form: inp.form?.id})),
    bundleFormId: bundleForm?.id
  });
  
  function formatMoney(amountInCents) {
    const amountInDollars = amountInCents / 100;
    return '$' + amountInDollars.toLocaleString('en-AU', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }



  function getCurrentQty() {
    const raw = (bundleQtyInput && bundleQtyInput.value) || (otherQtyInput && otherQtyInput.value) || '1';
    const n = Math.max(1, parseInt(raw, 10) || 1);
    return n;
  }

      function updateSelection() {
      let selectedRadio = bundleRoot.querySelector('input[type="radio"]:checked');
      let bundlePrice = 0;
      let itemCount = 1; // main product
  
      bundleItems.forEach(item => item.classList.remove('selected'));
  
      // Check if we have a meaningful selection (not the hidden none radio)
      const hasBundleSelection = selectedRadio && !selectedRadio.hasAttribute('data-bundle-none') && selectedRadio.value;
      
      log('updateSelection check', { 
        selectedRadio: selectedRadio ? selectedRadio.id || '(no-id)' : null, 
        hasDataBundleNone: selectedRadio ? selectedRadio.hasAttribute('data-bundle-none') : false,
        value: selectedRadio ? selectedRadio.value : null,
        hasBundleSelection 
      });
      
      if (hasBundleSelection) {
        bundlePrice = parseFloat(selectedRadio.dataset.priceValue);
        itemCount += 1;
        // Highlight selected item
        selectedRadio.closest('.\\#tdlv-product-bundle-item').classList.add('selected');
        // Hide native add to cart button and quantity
        if (otherAddButton) otherAddButton.style.display = 'none';
        if (nativeQtyContainer) nativeQtyContainer.style.display = 'none';
        // Show bundle footer
        footer.classList.remove('desktop-hidden', 'mobile-hidden');
        log('showing bundle controls, hiding native');
      }
      else {
        // No meaningful selection; show native controls and hide bundle footer
        if (otherAddButton) otherAddButton.style.display = '';
        if (nativeQtyContainer) nativeQtyContainer.style.display = '';
        footer.classList.add('desktop-hidden', 'mobile-hidden');
        log('showing native controls, hiding bundle footer');
      }

    // Update total price
    const total = mainProductPrice + bundlePrice;
    if (totalPriceEl) totalPriceEl.textContent = formatMoney(total);

    if (addToCartBtn) {
      const spanAmount = addToCartBtn.querySelector('span[data-i18n-amount]');
      if (spanAmount) {
        spanAmount.textContent = itemCount;
      }
    }

          // Remove any previous dynamic bundle inputs
    if (bundleForm) {
      // Only remove previously appended dynamic inputs
      bundleForm.querySelectorAll('[data-bundle-dynamic="true"]').forEach(input => input.remove());
    }

    // Find the selected bundle
    const selected = bundleRoot.querySelector('input[type="radio"]:checked');
    log('updateSelection()', { selectedValue: selected ? selected.value : null, price: bundlePrice, total });
    if (selected && bundleForm) {
      // Add the bundle item as items[][id] so Shopify accepts it alongside the main id/quantity
      const bundleInput = document.createElement('input');
      bundleInput.type = 'hidden';
      bundleInput.name = 'items[][id]';
      bundleInput.value = selected.value;
      bundleInput.setAttribute('data-bundle-dynamic', 'true');
      bundleForm.appendChild(bundleInput);

      const bundleQty = document.createElement('input');
      bundleQty.type = 'hidden';
      bundleQty.name = 'items[][quantity]';
      bundleQty.value = String(getCurrentQty());
      bundleQty.setAttribute('data-bundle-dynamic', 'true');
      bundleForm.appendChild(bundleQty);

      log('Appended bundle items[] to form', { bundleInputName: bundleInput.name, qtyName: bundleQty.name, qty: bundleQty.value });

      // Sync quantity from the native quantity input into our hidden quantity field
      if (bundleQtyInput && otherQtyInput && otherQtyInput.value) {
        bundleQtyInput.value = otherQtyInput.value;
        log('Synced quantity from native input', { value: bundleQtyInput.value });
      }

      // Ensure main product quantity matches current qty
      if (mainQtyHidden) {
        mainQtyHidden.value = String(getCurrentQty());
        log('Updated main product quantity', { value: mainQtyHidden.value });
      }
    }
  }


    // Listen for changes
  radioInputs.forEach(input => {
    // Track checked state to detect uncheck clicks
    let wasChecked = false;
    const label = input.id ? bundleRoot.querySelector(`label[for="${CSS.escape(input.id)}"]`) : null;

    const onMouseDown = () => {
      wasChecked = input.checked;
      log('mousedown on radio', { id: input.id || '(no-id)', wasChecked });
    };

    const onClick = (e) => {
      log('click on radio/label', { id: input.id || '(no-id)', wasChecked, currentChecked: input.checked, target: e.target.tagName });
      if (wasChecked) {
        e.preventDefault();
        log('unchecking bundle radio', { id: input.id, wasSelected: wasChecked });
        const none = bundleRoot.querySelector('input[type="radio"][data-bundle-none]');
        if (none) {
          log('selecting hidden none radio to uncheck bundle');
          none.checked = true;
          // Trigger change event and also manually call updateSelection
          none.dispatchEvent(new Event('change', { bubbles: true }));
          updateSelection();
        } else {
          log('no none radio found, directly unchecking');
          input.checked = false;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      } else {
        log('checking bundle radio', { id: input.id || '(no-id)', value: input.value });
      }
    };

    input.addEventListener('mousedown', onMouseDown);
    input.addEventListener('click', onClick);
    if (label) {
      label.addEventListener('mousedown', onMouseDown);
      label.addEventListener('click', onClick);
    }
    
   input.addEventListener('change', (e) => {
     log('radio change event', { id: e.target.id, value: e.target.value, price: e.target.dataset.priceValue, checked: e.target.checked });
     updateSelection();
   });
  });

  function syncQuantityBothWays() {
    if (!otherQtyInput || !bundleQtyInput) return;
    // Native -> Bundle
    otherQtyInput.addEventListener('input', () => {
      bundleQtyInput.value = otherQtyInput.value;
      log('quantity native->bundle', { value: bundleQtyInput.value });
      updateSelection();
    });
    // Bundle -> Native (if theme allows)
    bundleQtyInput.addEventListener('input', () => {
      otherQtyInput.value = bundleQtyInput.value;
      log('quantity bundle->native', { value: otherQtyInput.value });
      updateSelection();
    });
  }
  // Quantity +/- buttons
  const decBtn = bundleRoot.querySelector('[data-bundle-qty-dec]');
  const incBtn = bundleRoot.querySelector('[data-bundle-qty-inc]');
  if (decBtn && bundleQtyInput) {
    decBtn.addEventListener('click', () => {
      const val = Math.max(1, (parseInt(bundleQtyInput.value || '1', 10) - 1));
      bundleQtyInput.value = String(val);
      if (otherQtyInput) otherQtyInput.value = String(val);
      log('quantity dec', { value: val });
      updateSelection();
    });
  }
  if (incBtn && bundleQtyInput) {
    incBtn.addEventListener('click', () => {
      const val = Math.max(1, (parseInt(bundleQtyInput.value || '1', 10) + 1));
      bundleQtyInput.value = String(val);
      if (otherQtyInput) otherQtyInput.value = String(val);
      log('quantity inc', { value: val });
      updateSelection();
    });
  }

  syncQuantityBothWays();

  // Optional selection: if no bundle, submit main product as-is; if selected, ensure items[] appended
  if (bundleForm) {
    bundleForm.addEventListener('submit', function() {
      const selected = bundleRoot.querySelector('input[type="radio"]:checked');
      if (selected) {
        updateSelection();
        log('submit: bundle selected, appended items[]');
      } else {
        bundleForm.querySelectorAll('[data-bundle-dynamic="true"]').forEach(el => el.remove());
        log('submit: no bundle selected, submitting main product only');
      }
    }, true);
  }

});
